import React, { useState, useEffect } from "react";
import { siteSettingsTypes } from "../../../constant";
import SiteAreaPopup from "../popups/SiteAreaPopup";
import SiteSetupAreasPopups from "../popups/SiteSetupAreasPopups";
import COGAndTeeAndPOIEditPopup from "../popups/COGAndTeeAndPOIEditPopup";
import COGAndTeeAndPOIAddPopup from "../popups/COGAndTeeAndPOIAddPopup";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useHookstate } from "@hookstate/core";
import { SiteSetupAction, MAP_GLOBAL_STATES, SITEID_GLOBAL_STATE } from "globalStore/globalStore";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { CircleBtn } from "assets/css/globle";
import { handleEditChange } from "../functions/events/handleEditChange";
import { SiteSettingModalContainer } from "pages/Map/MapStyled";
import PaperComponent from "../PaperComponent";
import HoleAreaAlreadyExistsPopup from "../popups/HoleAreaAlreadyExistsPopup";

export const SiteArea = ({
    mapData,
    mapsData,
    openSiteAreaWindow,
    verticesCount,
    siteSetupDialogBox,
    setSiteSetupDialogBox,
    tempPolygon,
    siteAreaSaveActiveButton,
    cancelDialogOpen,
    tempSiteData,
    setOpenSiteAreaWindow,
    removeRequiredSiteAreaPolygon,
    setSiteAreaSaveActiveButton,
    openAreaWindow,
    courseNameModel,
    editSelectedData,
    tempSiteId,
    tempSiteEdit,
    courseNameHandleChange,
    holeNoModel,
    holeCount,
    setHoleCount,
    courseTypeModel,
    courseTypeHandleChange,
    siteSetupSaveActiveButton,
    siteSetupState,
    setTempPolygon,
    cancelMarkers,
    setSiteSetupSaveActiveButton,
    setOpenAreaWindow,
    removeRequiredHoleAreaPolygon,
    setHoleNoModel,
    openModel,
    setOpenModel,
    holeNo,
    setHoleNo,
    teeValue,
    setTeeValue,
    poiTypeValue,
    setPoiTypeValue,
    poiPositionValue,
    setPoiPositionValue,
    addCogTeePoiSaveActiveButton,
    setAddCogTeePoiSaveActiveButton,
    ourData,
    setOurData,
    teeMarkersDataState,
    setTeeMarkersDataState,
    teeMarkeSeetingId,
    editModel,
    pointsOfInterestDataState,
    setPointsOfInterestDataState,
    courseEditName,
    editHoleNo,
    setEditHoleNo,
    editId,
    setTeeEditCopy,
    setEditCogTeePoiSaveActiveButton,
    imagePreview,
    centerGreenDataState,
    setCenterGreenDataState,
    setEditModel,
    setPoiEditTypeCopy,
    setPoiEditPositionCopy,
    editCogTeePoiSaveActiveButton,
    teeEditValue,
    setTeeEditValue,
    modalState,
    handleEditCourseChange,
    poiEditTypeValue,
    setPoiEditTypeValue,
    poiEditPositionValue,
    setPoiEditPositionValue,
    deleteId,
    editLatLng,
    isNewEditPolygon,
    isNewEditPoi,
    isNewEditTee,
    isNewEditCog
}) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

    const {
        addSiteSetup,
        editSiteSetup,
        addSelectType,
        areaModified,
        isSaveSiteArea,
        isSaveHoleArea,
        teeSiteData,
        poiSiteData,
        showSiteData
    } = useHookstate(SiteSetupAction);

    const { carPopupClickEvent } = useHookstate(MAP_GLOBAL_STATES);

    const { siteSetupData } = useSelector((state) => state.commonReducers) || [];

    const [siteAreaType, setSiteAreaType] = useState(0);
    const [saveErrorModal, setSaveErrorModal] = useState(false);
    const [openAlertModal, setOpenAlertModal] = useState(false);
    const [popupState, setPopupState] = useState(false);
    const [courseName, setCourseName] = useState(-1);
    const [addCogDistan] = useState(0);
    const [teeHoleNumbers] = useState([]);
    const [poiHoleNumbers] = useState([]);
    const [cogDistan] = useState("");
    const [modalPos, setModalPos] = useState({ x: 100, y: 100 });
    const [areaHasBeenUpdated, setAreaHasBeenUpdated] = useState(null);

    useEffect(() => {
        if (!mapData || !siteSetupDialogBox) return;

        const { lat, lng } = siteSetupDialogBox;
        if (typeof lat !== "number" || typeof lng !== "number") return;

        const overlay = new mapsData.OverlayView();

        overlay.onAdd = function () {
            const projection = overlay.getProjection();
            if (!projection) return;

            const latLng = new mapsData.LatLng(lat, lng);
            const point = projection.fromLatLngToContainerPixel(latLng);

            if (!point || isNaN(point.x) || isNaN(point.y)) return; // validation

            setModalPos({
                x: point.x + 180, // offset
                y: point.y - 50,  // above marker
            });
        };

        overlay.draw = function () { };
        overlay.setMap(mapData);
    }, [mapData, siteSetupDialogBox?.lat, siteSetupDialogBox?.lng]);

    useEffect(() => {
        setEditCogTeePoiSaveActiveButton(false);
        setAddCogTeePoiSaveActiveButton(false);
        setSiteSetupSaveActiveButton(false);
        if (isNewEditPolygon() && editSiteSetup.get()) {
            setSiteSetupSaveActiveButton(true);
        } else if (!isNewEditPolygon()) {
            areaModified.set(false);
        }
        if ((isNewEditPoi() || isNewEditTee() || isNewEditCog()) && editSiteSetup.get()) {
            setEditCogTeePoiSaveActiveButton(true);
        }
        if (addSiteSetup.get()) {
            setEditCogTeePoiSaveActiveButton(true);
            setAddCogTeePoiSaveActiveButton(true);
            setSiteSetupSaveActiveButton(true);
            setSiteAreaSaveActiveButton(true);
        }
    }, [courseName,
        holeCount,
        teeValue,
        editHoleNo,
        poiEditPositionValue,
        poiEditTypeValue,
        holeNo,
        courseEditName,
        tempPolygon,
        verticesCount,
        teeEditValue,
        holeNoModel,
        courseNameModel,
        courseTypeModel,
        addSiteSetup.get(),
    ]);

    useEffect(() => {
        teeMarkersDataState?.map((el) => {
            return teeHoleNumbers.push(el?.Hole);
        });

        pointsOfInterestDataState?.map((el) => {
            return poiHoleNumbers.push(el?.Hole);
        });
    }, [teeMarkersDataState, pointsOfInterestDataState]);

    useEffect(() => {
        if (areaHasBeenUpdated != null && areaHasBeenUpdated) {
            dispatch(COMMON_SERVICES.getAllSiteSetupServices(siteId.get()));

            setAreaHasBeenUpdated(false);
        }
    }, [areaHasBeenUpdated]);

    const saveSiteArea = () => {
        editSelectedData?.setOptions({
            editable: false,
            fillOpacity: 0.2,
        });
        setSiteAreaSaveActiveButton(false);
        areaModified.set(false);

        let payload = {
            Id: addSiteSetup.get() ? 0 : tempSiteId[0].Id,
            SiteId: Number(siteId.get()),
            Polygon: addSiteSetup.get()
                ? tempPolygon
                : tempSiteEdit.length
                    ? tempSiteEdit
                    : tempSiteId[0].Polygon,
            Type: Number(siteAreaType),
        };

        if (addSiteSetup.get()) {
            dispatch(COMMON_SERVICES.postSiteAreaServices(payload)).then(() => {
                setAreaHasBeenUpdated(true);
            });
        } else if (editSiteSetup.get()) {
            dispatch(COMMON_SERVICES.putSiteAreaDataServices(payload, tempSiteId[0].Id, Number(siteId.get()))).then(() => {
                setAreaHasBeenUpdated(true);
            });
        }

        isSaveSiteArea.set(true);
    }

    const deleteSiteArea = () => {
        dispatch(COMMON_SERVICES.deleteSiteAreaServices(tempSiteData[0]?.Id, Number(siteId.get()))).then(() => {
            setOpenSiteAreaWindow(false);
            removeRequiredSiteAreaPolygon();
            setAreaHasBeenUpdated(true);
        });
    }

    const saveHoleArea = async () => {
        let apiData = siteSetupState && siteSetupState !== undefined && siteSetupState;

        if (siteSetupState && siteSetupState !== undefined) {
            let existHole = apiData[0]?.HoleAreas?.Hole?.includes(holeNoModel);

            if (existHole) {
                saveErrorModal(true);
                setTempPolygon([]);
            }

            let payload = {
                SiteId: Number(siteId.get()),
                Course: courseNameModel,
                Hole: Number(holeNoModel),
                Polygon: addSiteSetup.get()
                    ? tempPolygon
                    : tempSiteEdit.length
                        ? tempSiteEdit
                        : tempSiteId[0].Polygon,
                Type: Number(courseTypeModel),
            };

            if (addSiteSetup.get()) {
                const filteredData = siteSetupData?.HoleAreas?.filter(
                    (item) =>
                        payload?.Course === item?.Course &&
                        payload?.Hole === item?.Hole &&
                        payload?.Type === item?.Type
                );

                if (filteredData?.length && Number(courseTypeModel) !== 0) {
                    return setOpenAlertModal(true);
                } else {
                    setSiteSetupSaveActiveButton(false);
                    areaModified.set(false);
                    editSelectedData?.setOptions({
                        editable: false,
                        fillOpacity: 0.2,
                    });
                }

                dispatch(COMMON_SERVICES.postHoleAreaServices(payload)).then(() => {
                    setAreaHasBeenUpdated(true);
                });
            } else if (editSiteSetup.get()) {
                payload["Id"] = tempSiteId[0].Id;
                setSiteSetupSaveActiveButton(false);
                dispatch(COMMON_SERVICES.putHoleAreaDataServices(payload, tempSiteId[0].Id, Number(siteId.get()))).then(() => {
                    setAreaHasBeenUpdated(true);
                });
            }

            isSaveHoleArea.set(true);
        }
    }

    const deleteHoleArea = async () => {
        await dispatch(COMMON_SERVICES.deleteHoleAreaServices(tempSiteId[0].Id, Number(siteId.get()))).then(() => {
            setOpenAreaWindow(false);
            removeRequiredHoleAreaPolygon();
        });

        setAreaHasBeenUpdated(true);
    }

    const removeHoleMarker = () => {
        setPopupState(false);
        cancelMarkers();
    }

    const saveMarkers = () => {
        if (addSelectType.get() === siteSettingsTypes.centerOfGreen) {
            let existHole = teeHoleNumbers.includes(holeNo);
            if (existHole) {
                setPopupState(true);
                ourData.tee.pop();
            }
        } else if (addSelectType.get() === siteSettingsTypes.teeMarkers) {
            let getLatLng = ourData.tee.length - 1;
            let existHole = teeMarkersDataState.filter((t) => t.SiteId == siteId.get() && t.Hole === holeNo && t.TeeMarkerSettingId === teeValue && t.Course === courseName);
            if (existHole.length > 0) {
                setPopupState(true);
                ourData.tee.pop();
            }
            else {
                let payload = {
                    Id: 0,
                    SiteId: Number(siteId.get()),
                    TeeMarkerSettingId: teeValue,
                    Course: courseName,
                    Hole: holeNo,
                    Lat: ourData.tee[getLatLng]?.lat,
                    Lon: ourData.tee[getLatLng]?.lng,
                    SettingsTee: teeMarkeSeetingId,
                };

                dispatch(COMMON_SERVICES.postTeeMarkerServices(payload)).then(() => {
                    let item = {
                        SiteId: Number(siteId.get()),
                        TeeMarkerSettingId: teeValue,
                        Course: courseName,
                        Hole: holeNo,
                        Lat: ourData.tee[getLatLng]?.lat,
                        Lon: ourData.tee[getLatLng]?.lng,
                    }
                    const newDataTemp = [...teeMarkersDataState, item]
                    setTeeMarkersDataState(newDataTemp);
                    setHoleNo(holeNo);
                    setAreaHasBeenUpdated(true);
                });
                teeSiteData.set(true);
            }
        } else if (addSelectType.get() === siteSettingsTypes.pointOfInterest) {
            let getLatLng = ourData.poi.length - 1;

            let payload = {
                Course: courseName,
                Hole: holeNo,
                Id: 0,
                LabelPosition: poiPositionValue,
                Lat: ourData.poi[getLatLng]?.lat,
                Lon: ourData.poi[getLatLng]?.lng,
                SiteId: Number(siteId.get()),
                Type: poiTypeValue,
            };

            dispatch(COMMON_SERVICES.postPoiMarkerServices(payload)).then(() => {
                setOurData((prev) => ({
                    ...prev,
                    poi: [],
                }));
                poiSiteData.set(true);
                setPointsOfInterestDataState((prevData) => [...prevData, payload]);
                setAreaHasBeenUpdated(true);
            });
        }

        setOpenModel(false);
    }

    const saveEditMarkers = () => {
        setEditCogTeePoiSaveActiveButton(false);
        if (modalState === "poi") {
            let newDataTemp = JSON.parse(JSON.stringify(pointsOfInterestDataState));
            let filterData =
                newDataTemp &&
                newDataTemp.lenght !== 0 &&
                newDataTemp.filter((el) => {
                    return el?.Id === Number(editId);
                });

            filterData[0].Course = courseEditName;
            filterData[0].Hole = editHoleNo;
            filterData[0].Id = Number(editId);
            filterData[0].LabelPosition = poiEditPositionValue;
            filterData[0].Lat = editLatLng?.lat;
            filterData[0].Lon = editLatLng?.lng;
            filterData[0].SiteId = Number(siteId.get());
            filterData[0].Type = poiEditTypeValue;

            let chk = newDataTemp.findIndex((e) => e?.Id === Number(editId));

            newDataTemp[chk].Course = courseEditName;
            newDataTemp[chk].Hole = editHoleNo;
            newDataTemp[chk].Id = Number(editId);
            newDataTemp[chk].LabelPosition = poiEditPositionValue;
            newDataTemp[chk].Lat = editLatLng?.lat;
            newDataTemp[chk].Lon = editLatLng?.lng;
            newDataTemp[chk].SiteId = Number(siteId.get());
            newDataTemp[chk].Type = poiEditTypeValue;

            setPointsOfInterestDataState(newDataTemp);

            let payload = {
                Course: courseEditName,
                Hole: editHoleNo,
                Id: Number(editId),
                LabelPosition: poiEditPositionValue,
                Lat: editLatLng?.lat,
                Lon: editLatLng?.lng,
                SiteId: Number(siteId.get()),
                Type: poiEditTypeValue,
            };

            let siteIdGet = siteId.get();

            dispatch(COMMON_SERVICES.putPoiMarkerServices(payload, Number(editId), Number(siteId.get()))).then(() => {
                poiSiteData.set(true);
                let imageData = {
                    courseNumber: courseEditName,
                    holeNumber: editHoleNo,
                    siteIdGet,
                };
                imagePreview({}, imageData, {});

                setAreaHasBeenUpdated(true);
            });
        } else if (modalState === "tee") {
            let newDataTemp = JSON.parse(JSON.stringify(teeMarkersDataState));
            let filterData =
                newDataTemp &&
                newDataTemp.lenght !== 0 &&
                newDataTemp.filter((el) => {
                    return el?.Id === Number(editId);
                });

            filterData[0].Course = courseEditName;
            filterData[0].Hole = editHoleNo;
            filterData[0].Id = Number(editId);
            filterData[0].Lat = editLatLng?.lat;
            filterData[0].Lon = editLatLng?.lng;
            filterData[0].SiteId = Number(siteId.get());
            filterData[0].TeeMarkerSettingId = teeEditValue;

            let chk = newDataTemp.findIndex((e) => e?.Id === Number(editId));

            newDataTemp[chk].Course = courseEditName;
            newDataTemp[chk].Hole = editHoleNo;
            newDataTemp[chk].Id = Number(editId);
            newDataTemp[chk].Lat = editLatLng?.lat;
            newDataTemp[chk].Lon = editLatLng?.lng;
            newDataTemp[chk].SiteId = Number(siteId.get());
            newDataTemp[chk].TeeMarkerSettingId = teeEditValue;

            setTeeMarkersDataState(newDataTemp);

            let payload = {
                Course: courseEditName,
                Hole: editHoleNo,
                Id: Number(editId),
                Lat: editLatLng?.lat,
                Lon: editLatLng?.lng,
                SiteId: Number(siteId.get()),
                TeeMarkerSettingId: teeEditValue,
            };

            let siteIdGet = siteId.get();

            dispatch(COMMON_SERVICES.putTeeMarkerServices(payload, Number(editId), Number(siteId.get()))).then(() => {
                teeSiteData.set(true);

                let imageData = {
                    courseNumber: courseEditName,
                    holeNumber: editHoleNo,
                    siteIdGet,
                };
                imagePreview({}, imageData, {});

                setAreaHasBeenUpdated(true);
            });
        } else if (modalState === "cog") {
            let newDataTemp = JSON.parse(JSON.stringify(centerGreenDataState));
            let chk = newDataTemp.findIndex((e) => e?.Id === Number(editId));
            setCenterGreenDataState(newDataTemp);
            let payload = {
                Id: Number(editId),
                SiteId: Number(siteId.get()),
                Course: courseEditName,
                Hole: editHoleNo,
                Par: newDataTemp[chk].Par,
                Handicap: newDataTemp[chk].Handicap,
                CogLat: editLatLng?.lat,
                CogLon: editLatLng?.lng,
                ApproachViewYards: newDataTemp[chk].ApproachViewYards,
                StartTimeTee: newDataTemp[chk].StartTimeTee,
                StartTimeFairway: newDataTemp[chk].StartTimeFairway,
                StartAfterTee: newDataTemp[chk].StartAfterTee,
                IsStartHole: newDataTemp[chk].IsStartHole,
                IsTurnHole: newDataTemp[chk].IsTurnHole,
                ParL: newDataTemp[chk].ParL,
                HandicapL: newDataTemp[chk].HandicapL,
                HasHoleView: newDataTemp[chk].HasHoleView,
                MinHoleTimeMinutes: newDataTemp[chk].MinHoleTimeMinutes,
                BlindShotHole: newDataTemp[chk].BlindShotHole,
                BlindShotYardsFromCog: newDataTemp[chk].BlindShotYardsFromCog,
            };

            let siteIdGet = siteId.get();

            dispatch(COMMON_SERVICES.putCOGDataServices(payload, Number(editId), Number(siteId.get()))).then(() => {
                showSiteData.set(true);
                let imageData = {
                    courseNumber: courseEditName,
                    holeNumber: editHoleNo,
                    siteIdGet,
                };
                imagePreview({}, imageData, {});

                setAreaHasBeenUpdated(true);
            });
        }

        setEditModel(false);
    }

    const teeEditHandleChange = (event) => {
        let index = teeMarkersDataState.findIndex(
            (item) => item.Id === Number(editId)
        );
        const updatedData = [...teeMarkersDataState];
        updatedData[index] = {
            ...updatedData[index],
            TeeMarkerSettingId: event.target.value,
        };
        setTeeEditValue(event.target.value);
        setTeeEditCopy(event.target.value);
    }

    const poiEditHandleChange = (e) => {
        let index = pointsOfInterestDataState.findIndex(
            (item) => item.Id === Number(editId)
        );
        const updatedData = [...pointsOfInterestDataState];
        updatedData[index] = {
            ...updatedData[index],
            Type: e.target.value,
        };
        setPoiEditTypeValue(e.target.value);
        setPoiEditTypeCopy(e.target.value);
    }

    const poiEditPositionHandleChange = (e) => {
        let index = pointsOfInterestDataState.findIndex(
            (item) => item.Id === Number(editId)
        );
        const updatedData = [...pointsOfInterestDataState];
        updatedData[index] = {
            ...updatedData[index],
            LabelPosition: e.target.value,
        };
        setPoiEditPositionValue(e.target.value);
        setPoiEditPositionCopy(e.target.value);
    }

    return (
        <>
            {openSiteAreaWindow && verticesCount > 1 && (
                <SiteAreaPopup
                    modalPos={modalPos}
                    setSiteSetupDialogBox={setSiteSetupDialogBox}
                    siteAreaType={siteAreaType}
                    verticesCount={verticesCount}
                    tempPolygon={tempPolygon}
                    siteAreaSaveActiveButton={siteAreaSaveActiveButton}
                    cancelDialogOpen={cancelDialogOpen}
                    deleteSiteArea={deleteSiteArea}
                    saveSiteArea={saveSiteArea}
                    setSiteAreaSaveActiveButton={setSiteAreaSaveActiveButton}
                    setSiteAreaType={setSiteAreaType}
                />
            )}

            {openAreaWindow && tempPolygon.length > 1 && (
                <SiteSetupAreasPopups
                    modalPos={modalPos}
                    setSiteSetupDialogBox={setSiteSetupDialogBox}
                    courseNameModel={courseNameModel}
                    courseNameHandleChange={courseNameHandleChange}
                    holeNoModel={holeNoModel}
                    holeCount={holeCount}
                    verticesCount={verticesCount}
                    courseTypeModel={courseTypeModel}
                    courseTypeHandleChange={courseTypeHandleChange}
                    tempPolygon={tempPolygon}
                    siteSetupSaveActiveButton={siteSetupSaveActiveButton}
                    cancelDialogOpen={cancelDialogOpen}
                    deleteHoleArea={deleteHoleArea}
                    saveHoleArea={saveHoleArea}
                    setSiteSetupSaveActiveButton={setSiteSetupSaveActiveButton}
                    setHoleNoModel={setHoleNoModel}
                    areaModified={areaModified}
                />
            )}

            {openModel && (
                <COGAndTeeAndPOIAddPopup
                    modalPos={modalPos}
                    setSiteSetupDialogBox={setSiteSetupDialogBox}
                    courseName={courseName}
                    holeNo={holeNo}
                    holeCount={holeCount}
                    teeValue={teeValue}
                    addCogDistan={addCogDistan}
                    poiTypeValue={poiTypeValue}
                    poiPositionValue={poiPositionValue}
                    addCogTeePoiSaveActiveButton={addCogTeePoiSaveActiveButton}
                    cancelDialogOpen={cancelDialogOpen}
                    saveMarkers={saveMarkers}
                    setCourseName={setCourseName}
                    setHoleCount={setHoleCount}
                    setHoleNo={setHoleNo}
                    setAddCogTeePoiSaveActiveButton={setAddCogTeePoiSaveActiveButton}
                    setTeeValue={setTeeValue}
                    setPoiTypeValue={setPoiTypeValue}
                    setPoiPositionValue={setPoiPositionValue}
                />
            )}

            {editModel && carPopupClickEvent.get() === null && (
                <COGAndTeeAndPOIEditPopup
                    modalPos={modalPos}
                    courseEditName={courseEditName}
                    handleEditCourseChange={handleEditCourseChange}
                    editHoleNo={editHoleNo}
                    setEditHoleNo={setEditHoleNo}
                    handleEditChange={handleEditChange}
                    holeCount={holeCount}
                    teeEditValue={teeEditValue}
                    teeEditHandleChange={teeEditHandleChange}
                    cogDistan={cogDistan}
                    modalState={modalState}
                    poiEditTypeValue={poiEditTypeValue}
                    poiEditHandleChange={poiEditHandleChange}
                    poiEditPositionValue={poiEditPositionValue}
                    poiEditPositionHandleChange={poiEditPositionHandleChange}
                    saveEditMarkers={saveEditMarkers}
                    editCogTeePoiSaveActiveButton={editCogTeePoiSaveActiveButton}
                    cancelDialogOpen={cancelDialogOpen}
                    teeMarkersDataState={teeMarkersDataState}
                    setTeeMarkersDataState={setTeeMarkersDataState}
                    editId={editId}
                    deleteId={deleteId}
                    siteId={siteId.get()}
                    setEditModel={setEditModel}
                    pointsOfInterestDataState={pointsOfInterestDataState}
                    setPointsOfInterestDataState={setPointsOfInterestDataState}
                />
            )}

            <Dialog
                PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title"
                open={saveErrorModal}
                onClose={() => setSaveErrorModal(false)}
                sx={{ zIndex: 10001 }}
            >
                <SiteSettingModalContainer>
                    <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
                        Save Error
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <div style={{ margin: 20 }}>
                                This type of hole area already exists for this hole. Please select
                                a different area type to save.
                            </div>
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <CircleBtn onClick={() => setSaveErrorModal(false)}>
                            {t("Ok")}
                        </CircleBtn>
                    </DialogActions>
                </SiteSettingModalContainer>
            </Dialog>

            <Dialog
                PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title"
                open={popupState}
                onClose={() => setPopupState(false)}
                sx={{ zIndex: 10001 }}
            >
                <SiteSettingModalContainer>
                    <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
                        {addSelectType.get() === siteSettingsTypes.centerOfGreen && "Center of Green Error"}
                        {addSelectType.get() === siteSettingsTypes.teeMarkers && "Tee Marker Error"}
                        {addSelectType.get() === siteSettingsTypes.pointOfInterest && "Point of Interest Error"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {addSelectType.get() === siteSettingsTypes.centerOfGreen &&
                                "This Center of Green can not be added because it already exists. Please edit the existing Center of Green."}
                            {addSelectType.get() === siteSettingsTypes.teeMarkers &&
                                "This Tee Marker can not be added because it already exists. Please edit the existing Tee Marker."}
                            {addSelectType.get() === siteSettingsTypes.pointOfInterest &&
                                "This Point of Interest can not be added because it already exists. Please edit the existing Point of Interest."}
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <CircleBtn onClick={removeHoleMarker}>{t("Ok")}</CircleBtn>
                    </DialogActions>
                </SiteSettingModalContainer>
            </Dialog>


            <HoleAreaAlreadyExistsPopup
                openAlertModal={openAlertModal}
                setOpenAlertModal={setOpenAlertModal}
            />
        </>);
}